/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/Button";
import CaHeadsetIcon from "../../icons/CaHeadsetIcon";

const HelpButton = () => {
  return (
    <Button
      className="flex flex-row gap-2 rounded-[10px] text-[10px] bg-white text-black p-2 hover:bg-socials-whatsapp"
      onClick={() => {
        const siteWindow = window;
        if (Object.prototype.hasOwnProperty.call(siteWindow, "Intercom")) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const intercom: any = siteWindow?.Intercom;
          intercom("showMessages");
        }
      }}
    >
      <CaHeadsetIcon />
      Help
    </Button>
  );
};

export default HelpButton;
